import React, { ReactElement, useState, useRef, useEffect } from 'react'
import ReactPlayer from 'react-player'
import CustomPlayer from './CustomPlayer'
import { Container, Form, Button } from 'react-bootstrap'
import * as constant from '../constant'
import * as ajax from '../Utilities/ajax'
import { delay, getVideos } from '../Utilities/loadData'
import { AiOutlineSearch } from "react-icons/ai"
import { Pagination, Skeleton } from '@material-ui/lab'
import ScrollMenu from './ScrollMenu'
import '../Assets/videoPage.css'
import moment from 'moment'
import { MdPlayArrow } from "react-icons/md"
import { useHistory } from "react-router-dom"
import { getUrlQueries } from '../Utilities/url'

interface Props {
  props,
  section,
  setSection
}

const format = (seconds) => {
  if (isNaN(seconds)) {
    return '00:00'
  }
  const date = new Date(seconds * 1000)
  const hh = date.getUTCHours()
  const mm = date.getUTCMinutes()
  const ss = date.getUTCSeconds().toString().padStart(2, "0")
  return `${hh.toString().padStart(2, "0")}:${mm.toString().padStart(2, "0")}:${ss}`
}

const formatM = (seconds) => {
  if (isNaN(seconds)) {
    return '00:00'
  }
  const date = new Date(seconds * 1000)
  const hh = date.getUTCHours()
  const mm = date.getUTCMinutes()
  const ss = date.getUTCSeconds().toString().padStart(2, "0")
  if (hh) {
    return `${hh}:${mm.toString().padStart(2, "0")}:${ss}`
  }
  return `${mm.toString().padStart(2, "0")}:${ss}`
}

const checkTime = (TimeOutNew) => {
  const [cDay, cMonth, cYear] = moment(TimeOutNew).format("DD/MM/YYYY").split("/")
  const [cuDay, cuMonth, cuYear] = moment().format("DD/MM/YYYY").split("/")
  const _Year = parseInt(cuYear) - parseInt(cYear)
  const _Month = parseInt(cuMonth) - parseInt(cMonth)
  const _Day = parseInt(cuDay) - parseInt(cDay)
  if (_Year > 0 || _Month > 0 || _Day > 0) return false
  else return true
}

let count = 0

export default function PlayerForm({ props, section: globalSection, setSection: setGlobalSection }: Props): ReactElement {
  const history = useHistory()

  const [initialized, setInitialized] = useState(false)
  const [VideoNewGroup, setVideoNewGroup] = useState([])
  const [sections, setSections] = useState([])
  const [Stream, setStream] = useState("")
  const [FileImg, setFileImg] = useState(undefined)
  const [Description, setDes] = useState("")
  const [Title, setTitle] = useState("")
  const [id, setIdVideo] = useState(undefined)
  const [CreatedAt, setCreatedAt] = useState(undefined)
  const [newVideoOutOfTime, setNewVideoOutOfTime] = useState(undefined)
  const [idViewing, setIdViewing] = useState(undefined)
  const [search, setSearch] = useState(undefined)
  const [videoSearch, setVideoSearch] = useState([])
  const [section, setSection] = useState(null)
  const [indexVidePlaylist, setIndexVidePlaylist] = useState(1)
  const [numberOfView, setNumberOfView] = useState(undefined)
  const [tags, setTags] = useState([])
  const [moreDesc, setMoreDesc] = useState(undefined)
  const [videos_section, setVideos_section] = useState([])

  //! custom handle 
  const [loaded, setLoaded] = useState([] as string[])
  const [timeDisplayFormat, setTimeDisplayFormat] = useState("normal")
  const [playing, setPlaying] = useState(false)
  const [muted, setMuted] = useState(false)
  const [volume, setVolume] = useState(0.3)
  const [played, setPlayed] = useState(0)
  const [seeking, setSeeking] = useState(false)
  const [opacity, setOpaControl] = useState(1)
  const playerRef = useRef(null)
  const playContainerRef = useRef(null)
  const myRefs = useRef([])

  //! Helpers
  const selectVideo = (videos: any[], vid: number, playing = true) => {
    setVideos_section(videos)
    Search(undefined)

    const data = videos.find(x => x.id === vid)

    setPlaying(playing)
    setIdViewing(undefined)
    setStream(data.file_name)
    setDes(data.description)
    setTitle(data.title)
    setIdVideo(data.id)
    setIndexVidePlaylist(((videos || videos_section)?.findIndex(x => x.id === data.id) || 0) + 1)
    setCreatedAt(data.createdAt)
    setNewVideoOutOfTime(data.newVideoOutOfTime)
    setNumberOfView(data.view)
    setTags(data.tag)
    setFileImg(data.fileImage)
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  }

  //! intialize
  //? Initialize
  useEffect(() => {
    new Promise(async (r) => {
      const { videos, sections, welcome } = await getVideos()

      // sort videos by sections
      videos.sort((a, b) => {
        const _a = sections.findIndex(s => s.sectionName === a.groupName) || 0
        const _b = sections.findIndex(s => s.sectionName === b.groupName) || 0
        return _a === _b ? 0 : (_a < _b ? -1 : 1)
      }, 0)

      setVideoNewGroup(videos)
      setSections(sections)
      setStream(welcome && (welcome || {}).file_name)
      setDes(welcome && (welcome || {}).description)
      setTitle(welcome && (welcome || {}).title)
      setIdVideo(welcome && (welcome || {}).id)
      setCreatedAt(welcome && (welcome || {}).createdAt)
      setNewVideoOutOfTime(welcome && (welcome || {}).newVideoOutOfTime)
      setNumberOfView((welcome && (welcome || {}).view) || 0)
      setTags(welcome && (welcome || {}).tag)
      setFileImg(welcome && (welcome || {}).fileImage)
      setInitialized(true)
      setPlaying(false)

      //! Auto select video or section
      const queries = getUrlQueries()
      const _inputVid = queries.vid ? parseInt(queries.vid) : undefined
      const _inputSection = globalSection || queries.section || "All"
      if (_inputVid) {
        const selectedSection = videos.find(x => x.groupArray.some(y => y.id === _inputVid))
        const _videos = selectedSection?.groupArray

        selectVideo(_videos, _inputVid, false)
        setSection(_inputSection)
      }
      else if (_inputSection) {
        const videoSec = videos.filter(sec => sec.groupName === _inputSection)
        if (videoSec.length > 0) {
          setStream(videoSec[0].groupArray[0].file_name)
          setDes(videoSec[0].groupArray[0].description)
          setTitle(videoSec[0].groupArray[0].title)
          setIdVideo(videoSec[0].groupArray[0].id)
          setCreatedAt(videoSec[0].groupArray[0].createdAt)
          setNewVideoOutOfTime(videoSec[0].groupArray[0].newVideoOutOfTime)
          setNumberOfView((videoSec[0].groupArray[0].view) || 0)
          setTags(videoSec[0].groupArray[0].tag)
          setFileImg(videoSec[0].groupArray[0].fileImage)
          setVideos_section(videoSec[0].groupArray)
        }

        setSection(_inputSection)
        history.push(`/video?section=${_inputSection}`)
      }

      r(true)
    })

    // eslint-disable-next-line
  }, [])
  //? Delay Load Right Section
  useEffect(() => {
    const section = videos_section?.[0]?.section
    if (section) {
      const loop = async (curIdx) => {
        if (curIdx < (videos_section || []).length) {
          await delay(200)
          setLoaded(prev => [...new Set([...prev, `RS-${section}-${curIdx}`])])
          loop(curIdx + 1)
        }
      }
      loop(0)
    }

    // eslint-disable-next-line
  }, [videos_section?.[0]?.section])
  //? Delay Load Video Group
  useEffect(() => {
    if (VideoNewGroup) {
      const loop = async (curIdx) => {
        if (curIdx < (VideoNewGroup || []).length) {
          await delay(500)
          setLoaded(prev => [...new Set([...prev, `GR-${curIdx}`])])
          loop(curIdx + 1)
        }
      }
      loop(0)
    }

    // eslint-disable-next-line
  }, [VideoNewGroup])

  const handlePlayPause = () => {
    setPlaying(!playing)
  }

  const handleRewind = () => {
    playerRef.current.seekTo(playerRef.current.getCurrentTime() - 10)
  }
  const handleFastForward = () => {
    playerRef.current.seekTo(playerRef.current.getCurrentTime() + 10)
  }
  const handleMute = () => {
    setMuted(!muted)
  }
  const handleVolumeChange = (e, newVolume) => {
    setVolume(newVolume / 100)
    setMuted(newVolume === 0 ? true : false)
  }
  const handleVolumeSeekUp = (e, newVolume) => {
    setVolume(newVolume / 100)
    setMuted(newVolume === 0 ? true : false)
  }
  const handleSeekChange = (e, newValue) => {
    setIdViewing(undefined)
    setPlayed(newValue / 100)
  }
  const handleSeekMouseDown = (e) => {
    setIdViewing(undefined)
    setSeeking(true)
  }
  const handleSeekMouseUp = (e, newValue) => {
    setIdViewing(undefined)
    setSeeking(false)
    playerRef.current.seekTo(newValue / 100)
  }
  const handlePlayingEnded = () => {
    setPlaying(false)
  }
  const handleChangeDisPlayFormat = () => {
    setTimeDisplayFormat(timeDisplayFormat === "normal" ? 'remaining' : 'normal')
  }
  const currentTime = playerRef.current ? playerRef.current.getCurrentTime() : "00:00"

  const duration = playerRef.current ? playerRef.current.getDuration() : "00:00"
  const elapsedTime = timeDisplayFormat === "normal" ? formatM(currentTime) : `-${formatM(duration - currentTime)}`
  const totalDuration = formatM(duration)
  const handleMouseMove = () => {
    setOpaControl(1)
    count = 0
  }
  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.getElementById("player").requestFullscreen()
    } else {
      document.exitFullscreen()
    }
  }
  const handleProgress = (changeState) => {
    if (count > 0) {
      setOpaControl(0)
    }
    if (opacity === 1) {
      count += 1
    }
    if (!seeking) {
      setPlayed(changeState.played)
    }
    let _elapsedTime = format(currentTime)
    if (playing) {
      streaming(_elapsedTime)
    }
  }
  const streaming = async (time: any) => {
    if (!idViewing && time) {

      const { data } = await ajax.post("/video/streaming", {
        username: sessionStorage.getItem('username'),
        id: undefined,
        view_datatime: moment().format("YYYY-MM-DD HH:mm:ss"),
        video_id: id,
        video_start: time,
        video_end: time
      })
      if (!data.id) setPlaying(false)
      else setIdViewing(data.id)
    } else {
      const { data } = await ajax.post("/video/streaming", {
        id: idViewing,
        video_end: time
      })
      if (!data.id) setPlaying(false)
      else setIdViewing(data.id)
    }
  }
  const Search = (word) => {
    if (word === "") {
      setSearch(undefined)
    } else {
      setSearch(word)
    }
  }

  const handleSelectVideo = (vid: number) => {
    const selectedSection = VideoNewGroup.find(x => x.groupArray.some(y => y.id === vid))
    const videos = selectedSection?.groupArray
    if (videos) {
      selectVideo(videos, vid)
      history.push(`/video?vid=${vid}&section=${section}`)
    }
  }

  const handleSelectSection = (section: string) => {
    setSection(section)
    const queries = getUrlQueries()
    history.push(`/video?${queries.vid ? `vid=${queries.vid}&` : ""}section=${section}`)
  }

  const handleSearch = (e) => {
    Search(e)
    let videosearch = []
    const videosearchs = VideoNewGroup.map(v => v.groupArray)
    for (const _videosearchs of videosearchs) {
      for (const _searchData of _videosearchs) {
        if (
          (_searchData.title || "").toLowerCase().includes((e || "").toLowerCase())
          || (_searchData.file_name || "").toLowerCase().includes((e || "").toLowerCase())
          || (_searchData.tag || []).some(t => t.toLowerCase().includes((e || "").toLowerCase()))
        ) {
          videosearch.push(_searchData)
        }
      }
    }
    setVideoSearch(videosearch)
  }
  const handlePage = async (event: React.ChangeEvent<unknown>, value: number, groupName: String, groupArray: []) => {
    let videos_sections = []
    for (const v of VideoNewGroup) {
      if (v.groupName === groupName) {
        v.page = value
      }
      videos_sections.push(v)
    }
    setVideoNewGroup(videos_sections)
  }

  const handleMoreDesc = (i, e) => {
    e.preventDefault()
    setMoreDesc(i)
  }

  return (
    <div className="video-box" >
      <Container className="main-video">
        <div className={section === null ? "barSearch" : "barSearch2"} >
          <img className="image-lg pointer" src="/live.png" alt="err" onClick={() => setSection(null)} />
          <img className="image-xs" src="/iconplayer.png" alt="err" onClick={() => setSection(null)} />
          <div className="search-box">
            <Form.Control className="input-search" value={search} placeholder="Search" onChange={e => handleSearch(e.target.value)} />
            <div className="search">
              <AiOutlineSearch className="iconSearch" />
            </div>
          </div>
        </div>
        {!search && <div className="main-playlist" style={{ display: "flex", justifyContent: "space-between" }} >
          {/* Main Player */}
          <div className="videoView">
            {!initialized && <Skeleton variant="rect" className="skeleton-video" />}
            {initialized &&
              <div ref={playContainerRef} className="player" onClick={() => (playing || (currentTime && currentTime !== "00:00") || !FileImg) ? "" : handlePlayPause()} id="player">
                <ReactPlayer
                  className="player2"
                  id="player2"
                  ref={playerRef}
                  volume={volume}
                  url={`${constant.BASE_URL_VIDEO}/video/stream?file=${Stream}`}
                  muted={muted}
                  light={(playing || (currentTime && currentTime !== "00:00") || ["null", null, undefined].includes(FileImg)) ? false : `${constant.BASE_URL_VIDEO}/imgPreview/${FileImg}`}
                  playing={playing}
                  width="100%"
                  height="auto"
                  onProgress={handleProgress}
                  onEnded={handlePlayingEnded}
                />
                <div
                  onMouseMove={handleMouseMove}
                  onMouseOver={handleMouseMove}
                  style={{ opacity, transition: ".3s ease-in-out" }}
                >
                  {((currentTime && currentTime !== "00:00") || playing || FileImg === 'null') ? <CustomPlayer
                    onPlayPause={handlePlayPause}
                    playing={playing}
                    onRewind={handleRewind}
                    onFastForward={handleFastForward}
                    muted={muted}
                    onMute={handleMute}
                    valueChange={handleVolumeChange}
                    onVolumeSeekUp={handleVolumeSeekUp}
                    volume={volume}
                    onToggleFullScreen={toggleFullScreen}
                    played={played}
                    onSeek={handleSeekChange}
                    onSeekMouseDown={handleSeekMouseDown}
                    onSeekMouseUp={handleSeekMouseUp}
                    elapsedTime={elapsedTime}
                    totalDuration={totalDuration}
                    onChangeDisplayFormat={handleChangeDisPlayFormat}
                    title={Title}
                  /> : ""}
                </div>
              </div>
            }

            {!initialized && <>
              <Skeleton variant="rect" className="skeleton-release" />
              <Skeleton variant="rect" className="skeleton-title" />
              <Skeleton variant="rect" className="skeleton-view" />
            </>}
            {initialized && <div className="textView">
              {Title && <h5 className="break-all">{Title || ""}</h5>}
              {(tags || []).map((tag, i) =>
                <span className="video_tag" style={i === 0 ? {} : { marginLeft: 5 }} onClick={() => handleSearch(tag)} key={i}>#{tag}</span>
              )}
              {Description && <p className="description2 break-all" >{Description || ""}</p>}
              {numberOfView !== undefined && <span className="span" style={{ marginLeft: (tags.length > 0 && !Description) ? 5 : 0 }} >{`${numberOfView} views`}</span>}
              {CreatedAt ? <span className="span">{" • " + moment(CreatedAt).format('LL')}</span> : ""}
              {(CreatedAt && newVideoOutOfTime) && checkTime(newVideoOutOfTime) && <span className="new-video">New Release</span>}
            </div>}
          </div>

          {/* Right Section */}
          {section !== null && (videos_section || []).length > 1 && <div className="playlist">
            <div className="playlist-heard">
              <div className="heard-section">
                <h1 style={{ marginLeft: '10px', fontSize: 20, color: "#fff" }}>{videos_section.find(x => x.section)?.section.toLocaleUpperCase()}</h1>
                <h4 style={{ marginRight: '10px', color: "#fff" }}>{indexVidePlaylist + " / " + videos_section.length}</h4>
              </div>
              {(videos_section || []).map((d, i) =>
                <div key={i} className={id === d.id ? "video-section-list active" : "video-section-list"} style={i === 0 ? { marginTop: 10 } : {}}>
                  {loaded.includes(`RS-${videos_section?.[0]?.section}-${i}`)
                    ? (
                      <div className={Stream === d.file_name ? "section-video" : "section-video pointer"}>
                        <Button
                          id="btn-video-section player"
                          style={{ width: "100%", padding: 0, margin: 0, background: "transparent", border: "none" }}
                          onClick={() => {
                            (document.activeElement as HTMLElement).blur()
                            handleSelectVideo(d.id)
                            setSearch("")
                          }}
                          className="player"
                        >
                          <ReactPlayer
                            className="player2"
                            width="100%"
                            height="auto"
                            id="videoMM"
                            light={["null", null, undefined].includes(d.fileImage) ? false : `${constant.BASE_URL_VIDEO}/imgPreview/${d.fileImage}`}
                            style={{ pointerEvents: "none" }}
                            url={`${constant.BASE_URL_VIDEO}/video/stream?file=${d.file_name}`}
                          />
                          {["null", null, undefined].includes(d.fileImage) && <MdPlayArrow className="play-icon2" />}
                        </Button>
                      </div>
                    ) : (
                      <Skeleton variant="rect" className="section-video" style={{ height: "auto" }} />
                    )
                  }
                  <div className="section-text">
                    <h5 className="break-all">{d.title.length > 20 ? d.title.substr(0, 20) + "..." : d.title || ""}</h5>
                    <span style={{ color: "#ccc" }}>{d.view + " view • "}</span>
                    <span style={{ color: "#ccc" }}>{moment(d.createdAt).format('LL')}</span>
                  </div>
                </div>
              )}
            </div>
          </div>}
        </div>}

        <hr />

        {/* Video List */}
        {((VideoNewGroup || []).length === 0 && !initialized) && <Skeleton className="skeleton-section" height={120} />}
        {((VideoNewGroup || []).length > 0 || initialized) &&
          <>
            <div className="hind-pc" >{!search && <ScrollMenu section={section} sections={sections} setSection={setSection} />}</div>
            {!search && <div className="hind-xs">
              <div onClick={() => handleSelectSection("All")} className={section === "All" ? "menu-item-pc active" : "menu-item-pc"}>All</div>
              {(sections || []).map((sec, i) => <div key={i} style={{ marginLeft: 15 }} onClick={() => handleSelectSection(sec.sectionName)} className={sec.sectionName === section ? "menu-item-pc active" : "menu-item-pc"}>{sec.sectionName}</div>)}
            </div>}

            {search
              // Search Result
              ? (
                <div className="videoPlaylists">
                  {(videoSearch || []).map((d, i) =>
                    <div className="video" id="players" key={i}>
                      <Button
                        style={{ width: "100%", padding: 0, margin: 0, background: "transparent", border: "none" }}
                        onClick={() => {
                          (document.activeElement as HTMLElement).blur()
                          handleSelectVideo(d.id)
                          setSearch("")
                        }}
                        className="player"
                      >
                        <ReactPlayer
                          className="player2"
                          ref={el => (myRefs.current[i] = el)}
                          width="100%"
                          height="auto"
                          style={{ pointerEvents: "none" }}
                          light={["null", null, undefined].includes(d.fileImage) ? false : `${constant.BASE_URL_VIDEO}/imgPreview/${d.fileImage}`}
                          url={`${constant.BASE_URL_VIDEO}/video/stream?file=${d.file_name}`}
                          config={{
                            file: {
                              attributes: {
                                controlsList: 'nodownload'
                              }
                            }
                          }} />
                        {["null", null, undefined].includes(d.fileImage) && <MdPlayArrow className="play-icon" />}
                      </Button>
                      {d.viewer && <div style={{ position: "absolute", top: "5px", right: "5px", backgroundColor: "rgb(0,0,0,0.3)", color: "#fff", padding: "5px" }}>Watched</div>}
                      <div className="textView textView2">
                        {checkTime(d.newVideoOutOfTime) && <span className="new-video">{"New Release"}</span>}
                        <p>{d.title || ""}</p>
                        <p className="description" >{d.description && d.description.length > 100 ? d.description.substr(0, 100) + "..." : d.description || ""}</p>
                        <span className="span">{`${d.view} view • `}</span>
                        <span className="span">{moment(d.createdAt).format('LL')}</span>
                      </div>
                    </div>
                  )}
                </div>
              )
              // Video List by Sections
              : (
                (VideoNewGroup || []).filter(group => section === "All" ? group : group.groupName === section).map((group, index) => (
                  <div key={index}>
                    {loaded.includes(`GR-${index}`)
                      ? (
                        <div key={index} className="static">
                          {(["All", group.groupName].includes(section)) && index > 0 && <hr style={{ zIndex: 1000, marginBottom: "10px" }} />}
                          {(["All", group.groupName].includes(section)) && <h1 style={{ color: "#070d4b" }} >{group.groupName}</h1>}
                          <div className="videoPlaylists">
                            {(group.groupArray || [])
                              .filter((item, l) => section === "All" ? l < (group.page * 4) && l >= ((group.page - 1) * 4) : l < (group.page * 12) && l >= ((group.page - 1) * 12))
                              .map((d, _i) =>
                                <div className="video" id="players" key={_i}>
                                  <Button
                                    style={{ width: "100%", padding: 0, margin: 0, background: "transparent", border: "none" }}
                                    onClick={() => {
                                      (document.activeElement as HTMLElement).blur()
                                      handleSelectVideo(d.id)
                                      setSearch("")
                                    }}
                                    className="player"
                                  >
                                    <ReactPlayer
                                      ref={el => (myRefs.current[_i] = el)}
                                      width="100%"
                                      className="player2"
                                      height="auto"
                                      style={{ pointerEvents: "none" }}
                                      light={["null", null, undefined].includes(d.fileImage) ? false : `${constant.BASE_URL_VIDEO}/imgPreview/${d.fileImage}`}
                                      url={`${constant.BASE_URL_VIDEO}/video/stream?file=${d.file_name}`}
                                      config={{
                                        file: {
                                          attributes: {
                                            controlsList: 'nodownload'
                                          }
                                        }
                                      }} />
                                    {["null", null, undefined].includes(d.fileImage) && <MdPlayArrow className="play-icon" />}
                                  </Button>
                                  {d.viewer && <div style={{ position: "absolute", top: "5px", right: "5px", backgroundColor: "rgb(0,0,0,0.3)", color: "#fff", padding: "5px" }}>Watched</div>}
                                  <div className="textView textView2">
                                    {checkTime(d.newVideoOutOfTime) && <span className="new-video">{"New Release"}</span>}
                                    <p className="titles">{d.title || ""}</p>
                                    {d.description && <p className="description">{moreDesc !== d.id && d.description.length > 100 ? d.description.substr(0, 100) + "..." : d.description || ""}
                                      {d.description.length > 100 && // eslint-disable-next-line
                                        <a href="#" onClick={(e) => handleMoreDesc(d.id, e)}>
                                          {" more"}
                                        </a>
                                      }
                                    </p>}
                                    <span className="span">{d.view + ` views • `}</span>
                                    <span className="span">{moment(d.createdAt).format('LL')}</span>
                                  </div>
                                </div>
                              )}
                          </div>
                          <Pagination style={{ marginTop: 20 }} count={section === "All" ? group.countAll : group.count} page={group.page} onChange={(e, v) => handlePage(e, v, group.groupName, group.groupArray)} variant="outlined" shape="rounded" />
                        </div>
                      ) : (
                        <Skeleton variant="rect" className="static" />
                      )
                    }
                  </div>
                ))
              )
            }
          </>
        }
      </Container>
    </div>
  )
}
